export function formatTripDate(value) {
  if (!value) return ''

  return new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(value))
}

export function visibilityLabel(isPublic) {
  return isPublic ? 'Публичная' : 'Приватная'
}
